"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserVoteEpochRewardsSchema = exports.RebaseInfoSchema = exports.BribeInfoSchema = exports.BribeTokenInfoSchema = void 0;
const core_contracts_ifaces_1 = require("@tutellus/core-contracts-ifaces");
const zod_1 = require("zod");
exports.BribeTokenInfoSchema = zod_1.z.object({
    address: zod_1.z.string(),
    tokenID: zod_1.z.string(),
});
exports.BribeInfoSchema = zod_1.z.object({
    address: zod_1.z.string(),
    tokens: zod_1.z.array(exports.BribeTokenInfoSchema),
});
exports.RebaseInfoSchema = zod_1.z.object({
    lastClaimed: zod_1.z.string().datetime().optional().nullable(), // ISO 8601
    earned: core_contracts_ifaces_1.TokenAmountSchema,
    claimed: core_contracts_ifaces_1.TokenAmountSchema,
    pending: core_contracts_ifaces_1.TokenAmountSchema,
});
exports.UserVoteEpochRewardsSchema = zod_1.z.object({
    depositID: zod_1.z.number().int().min(0),
    bribesInfo: zod_1.z.array(exports.BribeInfoSchema),
    earned: zod_1.z.array(core_contracts_ifaces_1.CurrencyAmountSchema),
    claimed: zod_1.z.array(core_contracts_ifaces_1.CurrencyAmountSchema),
    pending: zod_1.z.object({
        total: zod_1.z.array(core_contracts_ifaces_1.CurrencyAmountSchema),
        incentives: zod_1.z.object({
            total: zod_1.z.array(core_contracts_ifaces_1.CurrencyAmountSchema),
            items: zod_1.z.array(core_contracts_ifaces_1.TokenAmountSchema),
        }),
        fees: zod_1.z.object({
            total: zod_1.z.array(core_contracts_ifaces_1.CurrencyAmountSchema),
            items: zod_1.z.array(core_contracts_ifaces_1.TokenAmountSchema),
        }),
    }),
    rebase: exports.RebaseInfoSchema,
});
